import { addUserTokens } from "../../lib/api";
import { User } from "../../lib/types";
import { Dialog, DialogTrigger, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { Label } from "../ui/label";
import { useState, useCallback } from "react";
import { Button } from "../ui/button";
import { DialogHeader, DialogFooter } from "../ui/dialog";
import { Input } from "../ui/input";

function UpdateTokens({user, refreshRowData} : {user:User, refreshRowData: () => void}) {
    const [openUpdateTokensDialog, setOpenUpdateTokensDialog] = useState<boolean>(false);
    const[ userTokens, setUserTokens] = useState<number>(0);
    const [userTokenError, setUserTokenError] = useState<string | null>(null);
    const [userTokenSuccess, setUserTokenSuccess] = useState<boolean>(false);

    const handleOpenUpdateTokensDialog = useCallback((open: boolean) => {
      setUserTokenError(null);
      setUserTokenSuccess(false);
      setUserTokens(0);
      setOpenUpdateTokensDialog(open);
    }, [user]);
  
    const handleTokenChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      setUserTokens(Number(e.target.value)); 
    };
    
    const handleSaveTokens = useCallback(async () => {
      if (userTokens !== null) {
        try {
          await addUserTokens(user.user_id, userTokens); 
          refreshRowData(); 
          setUserTokenSuccess(true);
        } catch (error) {
          console.error("Error adding tokens:", error);
          setUserTokenError("Error adding tokens");
        }
      }
    }, [user, userTokens, refreshRowData]);
  
    return (
      <Dialog open={openUpdateTokensDialog} onOpenChange={handleOpenUpdateTokensDialog}>
        <DialogTrigger asChild>
          <Button variant="outline" size="sm" title='Add tokens'>{user.user_tokens}</Button>
        </DialogTrigger>
        <DialogContent className="sm:max-w-[425px]">
          <DialogHeader>
            <DialogTitle>Add tokens</DialogTitle>
            <DialogDescription className='hidden'>
              Add tokens to user
            </DialogDescription>
          </DialogHeader>
          <div className="grid gap-4 py-4">
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="addtokens" className="text-right">
                Add Tokens
              </Label>
              <Input id="addtokens" type='number' value={userTokens} className="col-span-3" onChange={handleTokenChange} />
            </div>
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="id" className="text-right text-gray-500">
                ID
              </Label>
              <Input id="id" value={user.user_id} className="col-span-3 text-gray-500" readOnly/>
            </div>
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="name" className="text-right text-gray-500">
                Name
              </Label>
              <Input id="name" value={user.user_name} className="col-span-3 text-gray-500" readOnly/>
            </div>
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="useremail" className="text-right text-gray-500">
                Email
              </Label>
              <Input id="useremail" value={user.user_email} className="col-span-3 text-gray-500" readOnly/>
            </div>
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="usertokens" className="text-right text-gray-500">
                Tokens
              </Label>
              <Input id="usertokens" type='number' value={user.user_tokens} className={`col-span-3 text-gray-500 ${userTokenSuccess ? 'text-green-500' : ''}`} readOnly />
            </div>
          </div>
          <DialogFooter className="sm:justify-start">
            <Button type="button" onClick={handleSaveTokens}>Save changes</Button>
            {userTokenError && <p className="text-red-500">{userTokenError}</p>}
          </DialogFooter>
        </DialogContent>
      </Dialog>
    )
  }

export default UpdateTokens;